import styled from 'styled-components';

export const $StatusFilter = styled.div`
  margin-top: 0.75rem;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
`;

export const $StatusFilterLabel = styled.label`
  display: block;
  margin-bottom: 0.4rem;
  font-size: ${({ theme }) => theme.fonts?.size?.megaSmall ?? '0.75rem'};
  font-weight: ${({ theme }) => theme.fonts?.weight?.mediumFont ?? 500};
  color: ${({ theme }) =>
    theme.newUI?.defaultColors?.secondaryText ?? theme.colors?.paragraphTextColor ?? '#64748b'};
`;

export const $StatusFilterSelect = styled.select`
  width: 100%;
  padding: 0.625rem 0.75rem;
  font-size: ${({ theme }) => theme.fonts?.size?.small ?? '0.875rem'};
  border: 1px solid
    ${({ theme }) => theme.newUI?.inputBorderColors?.default ?? '#ccd2f9'};
  border-radius: ${({ theme }) => theme.newUI?.borders?.smallRadius ?? '4px'};
  background: ${({ theme }) =>
    theme.systemColors?.defaultBackground ?? theme.colors?.white ?? '#fff'};
  color: ${({ theme }) =>
    theme.newUI?.defaultColors?.text ?? theme.colors?.mainTextColor ?? '#333'};
  cursor: pointer;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors?.primary ?? '#5369eb'};
    box-shadow: 0 0 0 1px ${({ theme }) => theme.colors?.primary ?? '#5369eb'};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors?.primary ?? '#5369eb'};
    outline-offset: 2px;
  }
`;
